import React from "react";
import PropTypes from "prop-types";
import Component from "components/component";

export default class CustomInput extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    max: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      localValue: props.value,
      error: null
    };
  }

  componentDidMount() {
    // Runs the 'CUSTOM_VALUE_CHANGED' action on startup if a custom value is present
    // to ensure consistent display of price and quantity in the summary panel.
    const { value, max } = this.props;
    let val = value;
    if (val && withinRange(val, max) && isDimensionValid(val)) {
      val = formatValidDimension(val);
      this.updateValue(val);
    }
  }

  onChange = e => {
    this.updateValue(e.target.value);
  };

  updateValue = value => {
    const { max } = this.props;

    if (!withinRange(value, max)) {
      this.setState({
        error: `Please enter a number up to ${max}.`,
        localValue: value
      });

      return;
    }

    if (!isDimensionValid(value)) {
      this.setState({
        error:
          'Please enter a measurement in whole or half-inch (.5") increment',
        localValue: value
      });

      return;
    }

    value = formatValidDimension(value);

    this.setState(
      {
        error: null,
        localValue: value
      },
      () => {
        // Only update global state if dimension is valid
        this.props.onChange(value);
      }
    );
  };

  render() {
    const { error, localValue } = this.state;
    const { value, max } = this.props;

    // If the value in the global state is valid, show that
    // else show the local value so the user knows what they put
    const dimension = !error ? value : localValue;

    return (
      <div className="selection-details custom-size">
        <p>
          <span className="custom-size-input-label">Custom:</span>

          <input
            className="custom-size-input-field"
            type="number"
            step="0.5"
            id="custom-size-input"
            placeholder={`Max. ${max}"`}
            value={dimension}
            onChange={this.onChange}
          />
        </p>

        {error && <p className="error">{error}</p>}
      </div>
    );
  }
}

function withinRange(value, max) {
  return parseFloat(value, 10) < max;
}

function isDimensionValid(value) {
  return isWholeNumber(value) || isHalfInchNumber(value);
}

function isHalfInchNumber(value) {
  // Does it match 0.5 or 0.50000...
  return value.match(/\.50*$/) !== null;
}

function isWholeNumber(value) {
  return value.match(/\./) === null;
}

function formatValidDimension(value) {
  // Restrict to one decimal point if half inch
  value = value.replace(/\.50*$/, ".5");

  // Strip any 0 decimal points
  value = value.replace(/\.0*$/, "");

  return value;
}
